import { render, staticRenderFns } from "./ChangeEventsOverview.vue?vue&type=template&id=069d3e22&scoped=true&"
import script from "./ChangeEventsOverview.vue?vue&type=script&lang=js&"
export * from "./ChangeEventsOverview.vue?vue&type=script&lang=js&"
import style0 from "./ChangeEventsOverview.vue?vue&type=style&index=0&id=069d3e22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069d3e22",
  null
  
)

export default component.exports